module.exports={
	"Form": "SampleViewManifest",
	"Scope": "Sample-View",
	"Descriptors":
	{
		"SampleDetails.QRCode":
		{
			"Name": "QRCode",
			"Hash": "Sample-View-QRCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "Sample-View-Identity",
				"Group": "Sample-View-Identity"
			}
		},
		"SampleDetails.Name":
		{
			"Name": "Name",
			"Hash": "Sample-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "Sample-View-Identity",
				"Group": "Sample-View-Identity"
			}
		},
		"SampleDetails.ManufacturerCode":
		{
			"Name": "Manufacturer Code",
			"Hash": "Sample-View-ManufacturerCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "Sample-View-Identity",
				"Group": "Sample-View-Identity"
			}
		},
		"SampleDetails.DesignatedTime":
		{
			"Name": "Designated Time",
			"Hash": "Sample-View-DesignatedTime",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details"
			}
		},
		"SampleDetails.CaptureLatitude":
		{
			"Name": "Capture Latitude",
			"Hash": "Sample-View-CaptureLatitude",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details"
			}
		},
		"SampleDetails.CaptureLongitude":
		{
			"Name": "Capture Longitude",
			"Hash": "Sample-View-CaptureLongitude",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details"
			}
		},
		"SampleDetails.IDProject":
		{
			"Name": "Project",
			"Hash": "Sample-View-IDProject",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details",
				"Entity": "Project",
				"SearchFields":
				[
					"Name",
					"Description",
					"PurchaseOrderNumber",
					"ImprovementTypeCode"
				],
				"ReadOnly": true
			}
		},
		"SampleDetails.ParentIDSample":
		{
			"Name": "Parent Sample",
			"Hash": "Sample-View-ParentIDSample",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details",
				"Entity": "Sample",
				"SearchFields":
				[
					"QRCode",
					"Name",
					"LabControlNumber",
					"LabReferenceNumber"
				],
				"ReadOnly": true
			}
		},
		"SampleDetails.IDMaterial":
		{
			"Name": "Material",
			"Hash": "Sample-View-IDMaterial",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details",
				"Entity": "Material",
				"SearchFields":
				[
					"Name",
					"MaterialCode",
					"ItemCode"
				],
				"ReadOnly": true
			}
		},
		"SampleDetails.IDProductionPlant":
		{
			"Name": "Production Plant",
			"Hash": "Sample-View-IDProductionPlant",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "5",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details",
				"Entity": "ProductionPlant",
				"SearchFields":
				[
					"Name"
				],
				"ReadOnly": true
			}
		},
		"SampleDetails.IDLineItem":
		{
			"Name": "Line Item",
			"Hash": "Sample-View-IDLineItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "5",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details",
				"Entity": "LineItem",
				"SearchFields":
				[
					"Name",
					"ItemNumber"
				],
				"ReadOnly": true
			}
		},
		"SampleDetails.Notes":
		{
			"Name": "Notes",
			"Hash": "Sample-View-Notes",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 12,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details"
			}
		},
		"SampleDetails.Status":
		{
			"Name": "Status",
			"Hash": "Sample-View-Status",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details"
			}
		},
		"SampleDetails.LabControlNumber":
		{
			"Name": "Lab Control Number",
			"Hash": "Sample-View-LabControlNumber",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details"
			}
		},
		"SampleDetails.LabReferenceNumber":
		{
			"Name": "Lab Reference Number",
			"Hash": "Sample-View-LabReferenceNumber",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details"
			}
		},
		"SampleDetails.ProductName":
		{
			"Name": "Product Name",
			"Hash": "Sample-View-ProductName",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details"
			}
		},
		"SampleDetails.MaterialType":
		{
			"Name": "Material Type",
			"Hash": "Sample-View-MaterialType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details"
			}
		},
		"SampleDetails.IDOrganization":
		{
			"Name": "Organization",
			"Hash": "Sample-View-IDOrganization",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "8",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details",
				"Entity": "Organization",
				"SearchFields":
				[
					"Name",
					"VendorCode",
					"FederalTaxCode"
				],
				"ReadOnly": true
			}
		},
		"SampleDetails.IDMixDesign":
		{
			"Name": "Mix Design",
			"Hash": "Sample-View-IDMixDesign",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "9",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details",
				"Entity": "MixDesign",
				"SearchFields":
				[
					"MaterialCode",
					"Name",
					"Description"
				],
				"ReadOnly": true
			}
		},
		"SampleDetails.IntendedUse":
		{
			"Name": "Intended Use",
			"Hash": "Sample-View-IntendedUse",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "9",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details"
			}
		},
		"SampleDetails.BuyUSA":
		{
			"Name": "Buy USA",
			"Hash": "Sample-View-BuyUSA",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "9",
				"Width": 3,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details"
			}
		},
		"SampleDetails.ReceivedFrom":
		{
			"Name": "Received From",
			"Hash": "Sample-View-ReceivedFrom",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "10",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details"
			}
		},
		"SampleDetails.GeographicalArea":
		{
			"Name": "Geographical Area",
			"Hash": "Sample-View-GeographicalArea",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "10",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details"
			}
		},
		"SampleDetails.Station":
		{
			"Name": "Station",
			"Hash": "Sample-View-Station",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "10",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details"
			}
		},
		"SampleDetails.Offset":
		{
			"Name": "Offset",
			"Hash": "Sample-View-Offset",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "11",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details"
			}
		},
		"SampleDetails.RepresentedQuantity":
		{
			"Name": "Represented Quantity",
			"Hash": "Sample-View-RepresentedQuantity",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "11",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details"
			}
		},
		"SampleDetails.SampledQuantity":
		{
			"Name": "Sampled Quantity",
			"Hash": "Sample-View-SampledQuantity",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "11",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details"
			}
		},
		"SampleDetails.SampledQuantityUnits":
		{
			"Name": "Sampled Quantity Units",
			"Hash": "Sample-View-SampledQuantityUnits",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "12",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details"
			}
		},
		"SampleDetails.RepresentedQuantityUnits":
		{
			"Name": "Represented Quantity Units",
			"Hash": "Sample-View-RepresentedQuantityUnits",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "12",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details"
			}
		},
		"SampleDetails.Units":
		{
			"Name": "Units",
			"Hash": "Sample-View-Units",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "12",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details"
			}
		},
		"SampleDetails.RequestedBy":
		{
			"Name": "Requested By",
			"Hash": "Sample-View-RequestedBy",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "13",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details"
			}
		},
		"SampleDetails.IDSampleType":
		{
			"Name": "Sample Type",
			"Hash": "Sample-View-IDSampleType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "13",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details",
				"Entity": "SampleType",
				"SearchFields":
				[
					"Name",
					"Description"
				],
				"ReadOnly": true
			}
		},
		"SampleDetails.IDProduct":
		{
			"Name": "Product",
			"Hash": "Sample-View-IDProduct",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "13",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details",
				"Entity": "Product",
				"SearchFields":
				[
					"Name",
					"ManufacturerCode",
					"CatalogCode"
				],
				"ReadOnly": true
			}
		},
		"SampleDetails.SampledByIDUser":
		{
			"Name": "Sampled By IDUser",
			"Hash": "Sample-View-SampledByIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "14",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details"
			}
		},
		"SampleDetails.WitnessIDUser":
		{
			"Name": "Witness IDUser",
			"Hash": "Sample-View-WitnessIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "14",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details"
			}
		},
		"SampleDetails.AuthorizedIDUser":
		{
			"Name": "Authorized IDUser",
			"Hash": "Sample-View-AuthorizedIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "14",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details"
			}
		},
		"SampleDetails.CMSIDUser":
		{
			"Name": "CMSIDUser",
			"Hash": "Sample-View-CMSIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "15",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details"
			}
		},
		"SampleDetails.Datum":
		{
			"Name": "Datum",
			"Hash": "Sample-View-Datum",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "15",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details"
			}
		},
		"SampleDetails.Locked":
		{
			"Name": "Locked",
			"Hash": "Sample-View-Locked",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "15",
				"Width": 3,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details"
			}
		},
		"SampleDetails.Sequenced":
		{
			"Name": "Sequenced",
			"Hash": "Sample-View-Sequenced",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "16",
				"Width": 3,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details"
			}
		},
		"SampleDetails.IDSample":
		{
			"Name": "IDSample",
			"Hash": "Sample-View-IDSample",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "17",
				"Width": 4,
				"Section": "Sample-View-DataAudit",
				"Group": "Sample-View-DataAudit"
			}
		},
		"SampleDetails.GUIDSample":
		{
			"Name": "GUIDSample",
			"Hash": "Sample-View-GUIDSample",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "17",
				"Width": 4,
				"Section": "Sample-View-DataAudit",
				"Group": "Sample-View-DataAudit"
			}
		},
		"SampleDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "Sample-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "17",
				"Width": 4,
				"Section": "Sample-View-DataAudit",
				"Group": "Sample-View-DataAudit"
			}
		},
		"SampleDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "Sample-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "18",
				"Width": 4,
				"Section": "Sample-View-DataAudit",
				"Group": "Sample-View-DataAudit"
			}
		},
		"SampleDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "Sample-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "18",
				"Width": 4,
				"Section": "Sample-View-DataAudit",
				"Group": "Sample-View-DataAudit"
			}
		},
		"SampleDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "Sample-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "18",
				"Width": 4,
				"Section": "Sample-View-DataAudit",
				"Group": "Sample-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Sample-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Sample-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Sample-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Sample-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "Sample-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "Sample-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
